import Keyb from "keyb"
import Screenfull from "screenfull"

import Game from "@frog/source/models/Game.js"
import Audiomix from "@frog/source/models/juice/Audiomix.js"
import Director from "@frog/source/models/juice/Director.js"
import Stage from "@frog/source/models/Stage.js"
import Navigation from "@frog/source/models/Navigation.js"

export default new class App {
    update(delta) {
        if(Keyb.wasJustPressed("<escape>", delta.ms)) {
            if(Navigation.state.devscreen != undefined) {
                Navigation.state.devscreen = undefined
            } else if(this.game != undefined
            && this.game.encounter != undefined
            && this.game.encounter.selection != undefined
            && this.game.encounter.selection.selectedUnit != undefined) {
                // ...
            } else if(Navigation.state.screen == "EncounterScreen"
            || Navigation.state.screen == "OverworldScreen") {
                if(Navigation.state.minimenu == undefined) {
                    Navigation.state.minimenu = {"section": "MainSection"}
                } else if(Navigation.state.minimenu != undefined) {
                    if(Navigation.state.minimenu.section == "MainSection") {
                        Navigation.state.minimenu = undefined
                    } else if(Navigation.state.minimenu.section == "OptionsSection") {
                        Navigation.state.minimenu.section = "MainSection"
                    }
                }
            }
        }

        if(Navigation.state.minimenu != undefined) {
            // We're paused!!
            return
        }

        if(__STAGE__ == "DEVELOPMENT") {
            window._ = this
        }

        Director.update(delta)
        Audiomix.update(delta)

        if(this.game != undefined) {
            this.game.update(delta)
        }

        if(Keyb.wasJustPressed("F")
        && Keyb.isPressed("<shift>")) {
            Screenfull.toggle()
        }
    }
    load(app) {
        this.game = new Game()
        this.game = this.game.load(app.game)
    }
    loadTest(test) {
        if(test.snapshot == undefined) {
            console.log("Not a snapshot test:", test.slug)
            return
        }
        this.load({
            "navigation": {"screen": "EncounterScreen"},
            "game": {
                "encounter": {
                    "type": "combat",
                    "stage": test.snapshot.alphastage,
                    "steps": test.steps,
                    // "protoactions": test.snapshot.protoactions,
                }
            }
        })
    }
}
